/**
 * Secrets Collective — FAQ tabs + accordions.
 *
 * A custom element rather than a document-level listener so several FAQ
 * sections can sit on one page without fighting over each other's panels.
 *
 * The open/closed state lives on a class and aria-expanded, not on inline
 * styles, so the section's stylesheet keeps full control of the animation.
 */

class ScFaqTabs extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    const tab = event.target.closest('[data-tab]');
    if (tab && this.contains(tab)) {
      this.#selectTab(tab.dataset.tab);
      return;
    }

    const question = event.target.closest('.sc-faqt__q');
    if (question && this.contains(question)) this.#toggle(question);
  };

  #selectTab(id) {
    for (const button of this.querySelectorAll('[data-tab]')) {
      button.setAttribute('aria-selected', String(button.dataset.tab === id));
    }
    for (const panel of this.querySelectorAll('[data-panel]')) {
      panel.hidden = panel.dataset.panel !== id;
    }
  }

  #toggle(button) {
    const item = button.closest('.sc-faqt__item');
    if (!item) return;

    const open = !item.classList.contains('is-open');

    // One answer at a time — the list stays short enough to scan.
    for (const other of item.parentElement.querySelectorAll('.sc-faqt__item.is-open')) {
      if (other === item) continue;
      other.classList.remove('is-open');
      other.querySelector('.sc-faqt__q')?.setAttribute('aria-expanded', 'false');
    }

    item.classList.toggle('is-open', open);
    button.setAttribute('aria-expanded', String(open));
  }
}

if (!customElements.get('sc-faq-tabs')) {
  customElements.define('sc-faq-tabs', ScFaqTabs);
}
